<div class="camera-audit-dialog">
  <!-- Dialog Header -->
  <div class="dialog-header flex justify-content-between align-items-center py-spacing-3xl border-0">
    <div class="flex align-items-center gap-spacing-md">
      <h2 class="title-small-bold m-0">Camera audit log</h2>
      <span class="text-light-color body-medium_medium">{{ config.data.cameraOnlineStatus ? "Active" : "Offline" }} – Last Sync {{ lastSyncDate }}</span>
      <app-tag
        [content]="config.data.cameraOnlineStatus ? 'On' : 'Off'"
        styleClass="bold"
        sizeClass="tag-sm"
        [severityClass]="config.data.cameraOnlineStatus ? 'success' : 'danger'"></app-tag>
    </div>

    <div class="p-dialog-header-icons">
      <app-button
        (btnClick)="ref.close()"
        [iconOnlyButton]="true"
        icon="icon-x"
        sizeClass="p-button-sm"
        severity="secondary"
        [textButton]="true"></app-button>
    </div>
  </div>

  @if (auditLogs.length == 0) {
    <app-no-records></app-no-records>
  } @else {
    <!-- Table Container -->
    <div class="table-container">
      <p-table
        [value]="auditLogs"
        [scrollable]="true"
        [tableStyleClass]="'table-main-mode border-round-lg'">
        <ng-template #header>
          <tr>
            <th
              class="Utilities-Uppercase-sm-semi text-primary-color"
              scope="col">
              <span>TIMESTAMP</span>
            </th>
            <th
              class="Utilities-Uppercase-sm-semi text-primary-color"
              scope="col">
              <span>STATUS</span>
            </th>
            <th
              class="Utilities-Uppercase-sm-semi text-primary-color"
              scope="col">
              <span>RIDE ID</span>
            </th>
            <th
              class="Utilities-Uppercase-sm-semi text-primary-color"
              scope="col">
              <span>DRIVER ID</span>
            </th>
            <th
              class="Utilities-Uppercase-sm-semi text-primary-color"
              scope="col">
              <span>VEHICLE ID</span>
            </th>
            <th
              class="Utilities-Uppercase-sm-semi text-primary-color"
              scope="col">
              <span>CAMERA ID</span>
            </th>
          </tr>
        </ng-template>

        <ng-template
          #body
          let-log>
          <tr>
            <td class="label-large-regular text-primary-color">
              <span>{{ log.formattedTime }}</span>
            </td>
            <td>
              <app-tag
                [content]="log.camera_online_status ? 'On' : 'Off'"
                styleClass="bold"
                sizeClass="tag-sm"
                [severityClass]="log.camera_online_status ? 'success' : 'danger'"></app-tag>
            </td>
            <td class="label-large-regular text-primary-color">
              <span>{{ rideId }}</span>
            </td>
            <td class="label-large-regular text-primary-color">
              <span>{{ log.partner_id }}</span>
            </td>
            <td class="label-large-regular text-primary-color">
              <span>{{ log.vehicle_id }}</span>
            </td>
            <td class="label-large-regular text-primary-color">
              <span>{{ log.camera_id }}</span>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  }

  <!-- Dialog Footer -->
  <div class="dialog-footer flex justify-content-end py-spacing-3xl border-0">
    <app-button
      label="Close"
      (btnClick)="ref.close()"
      sizeClass="p-button-md"
      severity="secondary">
    </app-button>
  </div>
</div>
